// Display names for user roles (backend values remain unchanged)
// This file provides a single source of truth for all role display text
import i18n from '../i18n';

export const ROLE_DISPLAY_NAMES = {
  employer: 'Hiring Manager (full-time/long-term jobs)',
  owner: 'Project Owner (one-time gigs/projects)',
  job_seeker: 'Job Seeker (looking for stable job)',
  contractor: 'Contractor/Freelancer (project-based work)'
};

export const ROLE_DISPLAY_NAMES_SHORT = {
  employer: 'Hiring Manager',
  owner: 'Project Owner',
  job_seeker: 'Job Seeker',
  contractor: 'Contractor/Freelancer'
};

// Helper function to get translated role display name
export const getRoleDisplayName = (role, short = false) => {
  if (!role) return '';
  
  // Map roles to translation keys
  const roleKeyMap = {
    'employer': 'profile.employer',
    'owner': 'profile.owner',
    'job_seeker': 'profile.jobSeeker',
    'contractor': 'profile.contractor'
  };
  
  const key = roleKeyMap[role];
  if (key) {
    return i18n.t(key);
  }
  
  // Fallback to original behavior
  const displayNames = short ? ROLE_DISPLAY_NAMES_SHORT : ROLE_DISPLAY_NAMES;
  return displayNames[role] || role.replace('_', ' ');
};
